import { useRef } from 'react';
import { Quote } from 'lucide-react';
import { SectionHeading } from '../../components/SectionHeading';
import { useSpotlight } from '../../hooks';

interface Testimonial {
  quote: string;
  author: string;
  company: string;
  logo: string;
  /** Gradient tone class for the quote mark and accent bar (g-blue, …). */
  tone: string;
}

const TESTIMONIALS: ReadonlyArray<Testimonial> = [
  {
    quote:
      'Tokyo Medic Solutions had a great experience working with Inafana. They understood my requirements well and developed the expert system exactly according to my needs. They were professional, responsive, and easy to work with throughout the project. I’m really happy with the final result and would definitely recommend them to others looking for reliable web/app developers.',
    author: 'Abdullah',
    company: 'Tokyo Medic Solutions',
    logo: '/assets/logos/tokyomedic.png',
    tone: 'g-violet',
  },
  {
    quote:
      'Lumen ERP has been a great addition to our business operations. The system is simple, user-friendly, and continuously improving based on practical business requirements. We especially appreciate the responsive support and willingness to customize features according to our needs. Looking forward to seeing Lumen grow into an even more powerful ERP solution for businesses.',
    author: 'Ali Sandal',
    company: 'Elevani Industries',
    logo: '/assets/logos/elevani.png',
    tone: 'g-sun',
  },
];

export function Testimonials(): React.JSX.Element {
  const gridRef = useRef<HTMLDivElement>(null);
  useSpotlight(gridRef);

  return (
    <section id="testimonials" className="section-surface">
      <div className="container">
        <SectionHeading
          anim="float"
          title={
            <>
              In the words of <span className="si accent-text">the people we built for</span>.
            </>
          }
          lede="Not a survey score — what clients say once the system has been running in their business for a while."
        />
        <div className="testimonial-grid" ref={gridRef}>
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.author}
              className="testimonial-card reveal"
              data-spotlight
              data-delay={i + 1}
            >
              <span className={`testimonial-accent ${t.tone}`} aria-hidden="true" />
              <span className={`testimonial-mark ${t.tone}`} aria-hidden="true">
                <Quote size={16} strokeWidth={2.5} />
              </span>

              <blockquote>
                <p>{t.quote}</p>
              </blockquote>

              <figcaption className="testimonial-author">
                <img src={t.logo} alt="" loading="lazy" height={34} />
                <span className="testimonial-who">
                  <b>{t.author}</b>
                  <span>{t.company}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
